import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import TrailingSlashRedirect from "../../components/TrailingSlashRedirect";
import { MessagesInterceptor } from "../../helpers/socketInterceptors/MessagesInterceptor";
import { usePostHogIdentify } from "../../hooks/usePostHogIdentify";

const MainLayout = () => {
  usePostHogIdentify();

  return (
    <Layout className="theme-background-color">
      <TrailingSlashRedirect />
      <Outlet />
      <MessagesInterceptor />
    </Layout>
  );
};

export default MainLayout;
